module.exports = __webpack_public_path__ + "img/bag-dash.f1f53b2a.svg";